import React, { useState, useEffect } from 'react';
import {
    collection,
    query,
    where,
    getDocs,
    orderBy,
    doc,
    updateDoc,
    serverTimestamp,
    setDoc
} from 'firebase/firestore';
import { db } from '../firebase';

// Componente Modal simple
const Modal = ({ title, show, onClose, children }) => {
    if (!show) {
        return null;
    }

    const modalStyles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        },
        modalContent: {
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
            position: 'relative',
            animation: 'fadeIn 0.3s forwards'
        },
        closeButton: {
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666'
        }
    };

    return (
        <div style={modalStyles.overlay} onClick={onClose}>
            <div style={modalStyles.modalContent} onClick={e => e.stopPropagation()}>
                <button style={modalStyles.closeButton} onClick={onClose}>&times;</button>
                <h2 style={{ fontSize: '24px', marginBottom: '20px', fontWeight: 'bold' }}>{title}</h2>
                {children}
            </div>
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
            `}</style>
        </div>
    );
};

const SicDetalleFacturaSearch = () => {
    const [searchType, setSearchType] = useState('detalle');
    const [searchValue, setSearchValue] = useState('');
    const [allData, setAllData] = useState([]);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [inventarioFilter, setInventarioFilter] = useState('all'); // 'all', 'with', 'without'

    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [formValues, setFormValues] = useState({
        codigoComercialCodigo: '',
        codigo: '',
        detalle: '',
        Inventario: true
    });
    const [modalLoading, setModalLoading] = useState(false);
    const [modalError, setModalError] = useState('');

    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px'
        },
        title: {
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#333'
        },
        form: {
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            marginBottom: '24px'
        },
        formGroup: {
            marginBottom: '16px'
        },
        label: {
            display: 'block',
            marginBottom: '8px',
            fontWeight: '600',
            color: '#374151'
        },
        input: {
            width: '100%',
            padding: '12px',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            fontSize: '16px',
        },
        select: {
            padding: '12px',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            fontSize: '16px',
        },
        button: {
            padding: '12px 24px',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        buttonPrimary: {
            backgroundColor: '#3b82f6',
            color: 'white'
        },
        buttonSecondary: {
            backgroundColor: '#6b7280',
            color: 'white'
        },
        buttonSmall: {
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500'
        },
        error: {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#dc2626',
            padding: '16px',
            borderRadius: '6px',
            marginBottom: '16px'
        },
        loading: {
            textAlign: 'center',
            padding: '32px',
            color: '#6b7280'
        },
        spinner: {
            border: '2px solid #f3f3f3',
            borderTop: '2px solid #3b82f6',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
        },
        resultsContainer: {
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            overflow: 'hidden'
        },
        resultsHeader: {
            fontSize: '20px',
            fontWeight: '600',
            padding: '16px',
            backgroundColor: '#f9fafb'
        },
        tableWrapper: {
            maxHeight: '400px',
            overflowY: 'auto',
            overflowX: 'auto',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse'
        },
        tableHeader: {
            position: 'sticky',
            top: 0,
            backgroundColor: '#f3f4f6',
            padding: '12px',
            textAlign: 'left',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            textTransform: 'uppercase'
        },
        tableCell: {
            padding: '12px',
            borderBottom: '1px solid #e5e7eb',
            fontSize: '14px'
        },
        noResults: {
            textAlign: 'center',
            padding: '32px',
            color: '#6b7280'
        },
        actionButton: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            color: '#3b82f6',
            margin: '0 4px'
        }
    };

    const fetchData = async (q) => {
        setLoading(true);
        setError('');
        try {
            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map((d) => {
                const docData = d.data();
                const inventario = docData.Inventario !== undefined ? docData.Inventario : true;
                return {
                    id: d.id,
                    ...docData,
                    Inventario: inventario
                };
            });
            setAllData(data);
            setResults(data);
        } catch (err) {
            console.error('Error en búsqueda:', err);
            setError('Error al realizar la búsqueda: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const q = query(collection(db, 'SicDetalleFactura'), orderBy('codigoComercialCodigo'));
        fetchData(q);
    }, []);

    useEffect(() => {
        if (!allData.length) return;
        const trimmedValue = searchValue.trim().toLowerCase();
        let filteredResults = allData;

        // Aplicar filtro de inventario según la opción seleccionada
        if (inventarioFilter === 'with') {
            filteredResults = filteredResults.filter(item => item.Inventario === true);
        } else if (inventarioFilter === 'without') {
            filteredResults = filteredResults.filter(item => item.Inventario === false);
        }
        // Si es 'all', no filtramos por inventario

        if (trimmedValue) {
            filteredResults = filteredResults.filter(item => {
                let searchField;
                if (searchType === 'codigo') {
                    searchField = item.codigo;
                } else if (searchType === 'codigoComercial') {
                    searchField = item.codigoComercialCodigo;
                } else if (searchType === 'detalle') {
                    searchField = item.detalle;
                }
                return searchField && typeof searchField === 'string' && searchField.toLowerCase().includes(trimmedValue);
            });
        }
        setResults(filteredResults);
        setError(filteredResults.length === 0 && (trimmedValue || inventarioFilter !== 'all') ? 'No se encontraron resultados para su búsqueda o filtro.' : '');
    }, [searchValue, searchType, allData, inventarioFilter]);

    const formatDate = (date) => {
        if (date instanceof Date) {
            return date.toLocaleDateString('es-ES');
        } else if (date && date.toDate) {
            return date.toDate().toLocaleDateString('es-ES');
        }
        return 'N/A';
    };

    const handleOpenAddModal = () => {
        setIsEditing(false);
        setCurrentRecord(null);
        setFormValues({ codigoComercialCodigo: '', codigo: '', detalle: '', Inventario: true });
        setModalError('');
        setShowModal(true);
    };

    const handleOpenEditModal = (record) => {
        setIsEditing(true);
        setCurrentRecord(record);
        setFormValues({
            codigoComercialCodigo: record.codigoComercialCodigo || '',
            codigo: record.codigo || '',
            detalle: record.detalle || '',
            Inventario: record.Inventario
        });
        setModalError('');
        setShowModal(true);
    };

    const checkIfRecordExists = async (codigoComercialCodigo, currentId = null) => {
        const q = query(
            collection(db, 'SicDetalleFactura'),
            where('codigoComercialCodigo', '==', codigoComercialCodigo)
        );
        
        const snapshot = await getDocs(q);

        // Verificar si existe algún documento con el mismo código comercial que no sea el actual
        const exists = snapshot.docs.some(doc => {
            // Si estamos editando, ignorar el documento actual
            if (currentId && doc.id === currentId) return false;
            return true;
        });
        
        if (exists) {
            return 'El Código Comercial ya existe.';
        }
        return null;
    };

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        setModalLoading(true);
        setModalError('');

        if (!formValues.codigoComercialCodigo || !formValues.codigo || !formValues.detalle) {
            setModalError('Por favor, complete todos los campos.');
            setModalLoading(false);
            return;
        }

        // Validar que el código comercial no esté duplicado
        const duplicateError = await checkIfRecordExists(
            formValues.codigoComercialCodigo, 
            isEditing ? currentRecord.id : null
        );
        
        if (duplicateError) {
            setModalError(duplicateError);
            setModalLoading(false);
            return;
        }

        try {
            if (isEditing && currentRecord) {
                // Editar registro existente
                const docRef = doc(db, 'SicDetalleFactura', currentRecord.id);
                await updateDoc(docRef, { 
                    ...formValues, 
                    fechaActualizacion: serverTimestamp() 
                });
                
                const updatedAllData = allData.map(item =>
                    item.id === currentRecord.id ? { ...item, ...formValues, fechaActualizacion: new Date() } : item
                );
                setAllData(updatedAllData);
                setResults(updatedAllData);
            } else {
                // Crear nuevo registro - usar el código comercial ingresado por el usuario
                const newRecordData = {
                    codigoComercialCodigo: formValues.codigoComercialCodigo,
                    codigo: formValues.codigo,
                    detalle: formValues.detalle,
                    Inventario: formValues.Inventario,
                    fechaCreacion: serverTimestamp(),
                    fechaActualizacion: serverTimestamp()
                };

                // Agregar el documento con el ID específico (el código comercial)
                const docRef = doc(db, 'SicDetalleFactura', formValues.codigoComercialCodigo);
                await setDoc(docRef, newRecordData);

                const newDocData = { 
                    id: formValues.codigoComercialCodigo, 
                    ...newRecordData, 
                    fechaCreacion: new Date(), 
                    fechaActualizacion: new Date() 
                };
                
                const updatedAllData = [newDocData, ...allData];
                setAllData(updatedAllData);
                setResults(updatedAllData);
            }
            setShowModal(false);
        } catch (err) {
            console.error('Error al guardar el registro:', err);
            setModalError('Error al guardar el registro: ' + err.message);
        } finally {
            setModalLoading(false);
        }
    };

    const handleInventarioChange = async (id, currentStatus) => {
        try {
            const newStatus = !currentStatus;
            const docRef = doc(db, 'SicDetalleFactura', id);
            await setDoc(docRef, { Inventario: newStatus }, { merge: true });

            const updatedAllData = allData.map(item =>
                item.id === id ? { ...item, Inventario: newStatus } : item
            );
            setAllData(updatedAllData);

            const updatedResults = results.map(item =>
                item.id === id ? { ...item, Inventario: newStatus } : item
            );
            setResults(updatedResults);
        } catch (err) {
            console.error('Error al actualizar el inventario:', err);
            setError('Error al actualizar el inventario: ' + err.message);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={styles.title}>Catálogo de Productos</h1>
                <button
                    style={{ ...styles.button, ...styles.buttonPrimary, ...styles.buttonSmall }}
                    onClick={handleOpenAddModal}
                >
                    + Agregar Producto
                </button>
            </div>

            <form style={styles.form} onSubmit={(e) => e.preventDefault()}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <div style={{ flex: 'none' }}>
                        <label style={styles.label}>Tipo de Búsqueda</label>
                        <select
                            value={searchType}
                            onChange={(e) => setSearchType(e.target.value)}
                            style={styles.select}
                        >
                            <option value="detalle">Por Detalle</option>
                            <option value="codigo">Por CAByS</option>
                            <option value="codigoComercial">Por Código Comercial</option>
                        </select>
                    </div>
                    <div style={{ flex: '1' }}>
                        <label style={styles.label}>Buscar</label>
                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            style={styles.input}
                            placeholder="Ingrese su búsqueda..."
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <label style={styles.label}>Filtrar:</label>
                        <select
                            value={inventarioFilter}
                            onChange={(e) => setInventarioFilter(e.target.value)}
                            style={styles.select}
                        >
                            <option value="all">Todos</option>
                            <option value="with">Con Inventario</option>
                            <option value="without">Sin Inventario</option>
                        </select>
                    </div>
                </div>
            </form>

            {error && <div style={styles.error}>{error}</div>}
            {loading && (
                <div style={styles.loading}>
                    <div style={styles.spinner}></div>
                    <p style={{ marginTop: '16px' }}>Buscando registros...</p>
                </div>
            )}

            {results.length > 0 && (
                <div style={styles.resultsContainer}>
                    <h2 style={styles.resultsHeader}>Resultados ({results.length})</h2>
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.tableHeader}>#</th>
                                    <th style={styles.tableHeader}>Código Comercial</th>
                                    <th style={styles.tableHeader}>CAByS</th>
                                    <th style={styles.tableHeader}>Detalle</th>
                                    <th style={styles.tableHeader}>Inventario</th>
                                    <th style={styles.tableHeader}>Fecha Creación</th>
                                    <th style={styles.tableHeader}>Fecha Actualización</th>
                                    <th style={styles.tableHeader}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {results.map((item, index) => (
                                    <tr key={item.id}>
                                        <td style={styles.tableCell}>{index + 1}</td>
                                        <td style={styles.tableCell}>{item.codigoComercialCodigo || 'N/A'}</td>
                                        <td style={styles.tableCell}>{item.codigo || 'N/A'}</td>
                                        <td style={styles.tableCell}>{item.detalle || 'N/A'}</td>
                                        <td style={styles.tableCell}>
                                            <input
                                                type="checkbox"
                                                checked={item.Inventario}
                                                onChange={() => handleInventarioChange(item.id, item.Inventario)}
                                            />
                                        </td>
                                        <td style={styles.tableCell}>
                                            {formatDate(item.fechaCreacion)}
                                        </td>
                                        <td style={styles.tableCell}>
                                            {formatDate(item.fechaActualizacion)}
                                        </td>
                                        <td style={styles.tableCell}>
                                            <button
                                                style={styles.actionButton}
                                                onClick={() => handleOpenEditModal(item)}
                                                title="Editar Registro"
                                            >
                                                ✏️
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {results.length === 0 && !loading && !error && (
                <div style={styles.noResults}>
                    No se encontraron resultados.
                </div>
            )}

            <Modal
                title={isEditing ? 'Editar Producto' : 'Agregar Nuevo Producto'}
                show={showModal}
                onClose={() => setShowModal(false)}
            >
                <form onSubmit={handleModalSubmit}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={styles.label}>Código Comercial</label>
                        <input
                            type="text"
                            name="codigoComercialCodigo"
                            value={formValues.codigoComercialCodigo}
                            onChange={(e) => setFormValues({ ...formValues, codigoComercialCodigo: e.target.value })}
                            style={styles.input}
                            placeholder="Código Comercial"
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={styles.label}>Código CAByS</label>
                        <input
                            type="text"
                            name="codigo"
                            value={formValues.codigo}
                            onChange={(e) => setFormValues({ ...formValues, codigo: e.target.value })}
                            style={styles.input}
                            placeholder="Código CAByS"
                        />
                    </div>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={styles.label}>Detalle</label>
                        <input
                            type="text"
                            name="detalle"
                            value={formValues.detalle}
                            onChange={(e) => setFormValues({ ...formValues, detalle: e.target.value })}
                            style={styles.input}
                            placeholder="Detalle del producto"
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px' }}>
                        <input
                            type="checkbox"
                            name="Inventario"
                            checked={formValues.Inventario}
                            onChange={(e) => setFormValues({ ...formValues, Inventario: e.target.checked })}
                            id="modalInventario"
                        />
                        <label htmlFor="modalInventario">Con Inventario</label>
                    </div>
                    {modalError && <div style={styles.error}>{modalError}</div>}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button
                            type="button"
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                            onClick={() => setShowModal(false)}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                            disabled={modalLoading}
                        >
                            {modalLoading ? 'Guardando...' : (isEditing ? 'Guardar Cambios' : 'Agregar Registro')}
                        </button>
                    </div>
                </form>
            </Modal>

            <style>
                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}
            </style>
        </div>
    );
};

export default SicDetalleFacturaSearch;